<template>
    <div class="approval-manager-container">
        <!-- Page Header -->
        <div class="tw-header-card mb-4">
            <div class="d-flex align-center justify-space-between flex-wrap" style="gap: 12px;">
                <div class="d-flex align-center">
                    <div class="tw-header-icon mr-3">
                        <v-icon size="24" color="white">mdi-file-sign</v-icon>
                    </div>
                    <div>
                        <h1 class="text-h6 font-weight-black text-slate-900 mb-0">
                            CIRCUITO DE APROBACIÓN DE TRANSPORTISTAS
                        </h1>
                        <p class="text-caption text-slate-500 mb-0">
                            Configura dinámicamente la secuencia jerárquica y autorizaciones de vehículos.
                        </p>
                    </div>
                </div>
                <div class="tw-stats-badge d-flex align-center">
                    <div class="tw-stat-item text-center px-3 py-1">
                        <div class="text-subtitle-1 font-weight-black text-primary mb-0">{{ approvalSequence.length }}
                        </div>
                        <div class="text-caption font-weight-bold text-slate-400"
                            style="font-size: 0.65rem !important;">Niveles Activos</div>
                    </div>
                </div>
            </div>
        </div>

        <v-row>
            <!-- Left Column: Añadir Firma Secuencial -->
            <!-- <v-col cols="12" md="4" lg="4">
                <div class="tw-card">
                    <div class="tw-card-header">
                        <div class="tw-icon-box primary-box">
                            <v-icon color="primary" size="20">mdi-folder-plus</v-icon>
                        </div>
                        <h2 class="tw-title">Añadir Firma Secuencial</h2>
                    </div>

                    <div class="tw-divider"></div>

                    <div class="tw-form-group">
                        <label class="tw-label">Nombre del Aprobador:</label>
                        <input type="text" v-model="form.name" placeholder="Ej. Dr. Alejandro Peralta" class="tw-input"
                            @keyup.enter="injectLevel" />
                    </div>

                    <div class="tw-form-group mt-2">
                        <label class="tw-label">Puesto Organizacional:</label>
                        <div class="tw-select-wrapper">
                            <select v-model="form.position" class="tw-select">
                                <option disabled value="">Seleccionar puesto...</option>
                                <option v-for="(pos, idx) in availablePositions" :key="idx" :value="pos">
                                    {{ pos }}
                                </option>
                            </select>
                            <v-icon class="tw-select-arrow" size="20">mdi-chevron-down</v-icon>
                        </div>
                    </div>

                    <div class="tw-form-group mt-2">
                        <label class="d-flex align-center cursor-pointer select-none">
                            <div class="custom-switch-wrapper mr-3">
                                <input type="checkbox" v-model="form.active" class="custom-switch-input">
                                <span class="custom-switch-slider"></span>
                            </div>
                            <span class="text-caption font-weight-black text-slate-800 tracking-wide uppercase">
                                ESTADO
                            </span>
                        </label>
                    </div>
                    <button type="button" class="tw-btn-inject rounded-lg"
                        :class="{ 'tw-btn-disabled': !isFormValid, 'tw-btn-active': isFormValid }"
                        :disabled="!isFormValid" @click="injectLevel">
                        GUARDAR
                    </button>
                </div>
            </v-col> -->

            <!-- Right Column: Secuencia Jerárquica de Firmas -->
            <v-col cols="12" md="12" lg="12">
                <div class="tw-card">
                    <!-- Card Header -->
                    <div class="tw-card-header mb-1">
                        <div class="tw-icon-box purple-box">
                            <v-icon color="#4f46e5" size="20">mdi-source-branch</v-icon>
                        </div>
                        <h2 class="tw-title">Secuencia Jerárquica de Firmas (Arrastra para reordenar)</h2>
                    </div>

                    <!-- Subtitle -->
                    <div class="tw-subtitle mb-2">
                        <v-icon size="16" color="#3b82f6" class="mr-1.5">mdi-swap-vertical</v-icon>
                        <span>Mantén presionado y mueve las filas para alterar el flujo de autorización MTC en tiempo
                            real.</span>
                    </div>

                    <div class="tw-divider"></div>

                    <!-- Draggable Sequence List -->
                    <draggable v-model="approvalSequence" handle=".drag-handle" ghost-class="tw-ghost-row"
                        animation="250">
                        <transition-group type="transition" name="flip-list" tag="div" class="tw-sequence-list">
                            <div v-for="(item, index) in approvalSequence" :key="item.id" class="tw-sequence-item">
                                <div class="d-flex align-center flex-grow-1 min-w-0">
                                    <!-- Drag Handle -->
                                    <div class="drag-handle mr-3" title="Arrastrar para ordenar">
                                        <v-icon size="22" color="#94a3b8">mdi-dots-grid</v-icon>
                                    </div>

                                    <!-- Step Badge -->
                                    <div class="tw-step-badge mr-4">
                                        {{ index + 1 }}
                                    </div>

                                    <!-- Content Info -->
                                    <div class="min-w-0 flex-grow-1">
                                        <div class="tw-role-title text-truncate">
                                            {{ item.position }}
                                        </div>
                                        <div class="tw-person-name text-truncate">
                                            {{ item.name }}
                                        </div>
                                    </div>
                                </div>

                                <!-- Status Switch -->
                                <div class="d-flex align-center mr-3">
                                    <label class="d-flex align-center cursor-pointer select-none mb-0">
                                        <div class="custom-switch-wrapper">
                                            <input type="checkbox" v-model="item.active" class="custom-switch-input">
                                            <span class="custom-switch-slider"></span>
                                        </div>
                                    </label>
                                </div>

                                <!-- Actions -->
                                <div class="d-flex align-center ml-3">
                                    <button type="button" class="tw-action-btn tw-edit-btn mr-1" title="Editar firma"
                                        @click="editLevel(item)">
                                        <v-icon size="20" color="#f97316">mdi-pencil-outline</v-icon>
                                    </button>
                                    <button type="button" class="tw-action-btn tw-delete-btn" title="Eliminar firma"
                                        @click="removeLevel(index)">
                                        <v-icon size="20" color="#ef4444">mdi-delete-outline</v-icon>
                                    </button>
                                </div>
                            </div>
                        </transition-group>
                    </draggable>

                    <!-- Empty State -->
                    <div v-if="approvalSequence.length === 0" class="tw-empty-state py-10 text-center">
                        <v-icon size="48" color="#cbd5e1" class="mb-3">mdi-file-tree</v-icon>
                        <h3 class="text-subtitle-1 font-weight-bold text-slate-700">No hay niveles de firma definidos
                        </h3>
                        <p class="text-body-2 text-slate-400 max-w-sm mx-auto">
                            Utiliza el formulario de la izquierda para inyectar nuevos niveles en el circuito de
                            autorización.
                        </p>
                    </div>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import draggable from "vuedraggable";

let nextId = 4;

export default {
    name: "ManagementApprovalVehicle",
    components: {
        draggable
    },
    data() {
        return {
            form: {
                name: "",
                position: "Gerente de Operaciones (Despacho)",
                active: true
            },
            availablePositions: [
                "Gerente de Operaciones (Despacho)",
                "Administrador de Flotas",
                "Control de Patio",
                "Gerente de Logística",
                "Jefe de Seguridad Vial",
                "Responsable MTC / Legal"
            ],
            approvalSequence: [
                {
                    id: 1,
                    position: "GERENTE DE OPERACIONES",
                    name: "Dr. Alejandro Peralta",
                    active: true
                },
                {
                    id: 2,
                    position: "ADMINISTRADOR DE FLOTAS",
                    name: "Lic. Sofía Benites",
                    active: true
                },
                {
                    id: 3,
                    position: "CONTROL DE PATIO",
                    name: "Ing. Raúl Castro",
                    active: true
                }
            ],
            infoUser: {}
        };
    },
    computed: {
        isFormValid() {
            return this.form.name.trim() !== "" && this.form.position.trim() !== "";
        }
    },
    methods: {
        injectLevel() {
            if (!this.isFormValid) return;

            this.approvalSequence.push({
                id: nextId++,
                position: this.form.position.toUpperCase(),
                name: this.form.name.trim(),
                active: this.form.active
            });

            this.form.name = "";
            this.form.active = true;
            this.$fun && this.$fun.alert ? this.$fun.alert("Nivel inyectado en la secuencia.", "success") : null;
        },
        editLevel(item) {
            if (this.$fun && this.$fun.alert) {
                this.$fun.alert(`Editar referencial para: ${item.name}`, "info");
            }
        },
        removeLevel(index) {
            const removed = this.approvalSequence[index];
            this.approvalSequence.splice(index, 1);
            if (this.$fun && this.$fun.alert) {
                this.$fun.alert(`Se eliminó a ${removed.name} del circuito.`, "success");
            }
        },
        saveCircuit() {
            if (this.$fun && this.$fun.alert) {
                this.$fun.alert("Circuito jerárquico guardado correctamente en el sistema.", "success");
            }
        }
    },
    created() {
        this.infoUser = this.$fun.getUserInfo();
        console.log(JSON.parse(JSON.stringify(this.infoUser)))
        // TkpID: this.filterTkpID,
        // AreID: (userInfo && userInfo.CtrContract) ? (userInfo.CtrContract.AreID ?? 0) : 0,
        // PrsID: (userInfo) ? (userInfo.PrsID ?? null) : null,
    }
};
</script>

<style scoped>
.approval-manager-container {
    /* min-height: calc(100vh - 64px); */
}

/* Modern Header */
.tw-header-card {
    background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
    border: 1px solid #e2e8f0;
    border-radius: 14px;
    padding: 12px 18px;
    box-shadow: 0 4px 12px -2px rgba(0, 0, 0, 0.03);
}

.tw-header-icon {
    width: 42px;
    height: 42px;
    border-radius: 12px;
    background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 12px rgba(37, 99, 235, 0.22);
    flex-shrink: 0;
}

.tw-badge {
    background-color: #eff6ff;
    color: #2563eb;
    border: 1px solid #bfdbfe;
    font-size: 0.68rem;
    font-weight: 800;
    padding: 2px 8px;
    border-radius: 12px;
    letter-spacing: 0.06em;
    display: inline-block;
}

.tw-stats-badge {
    background-color: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 14px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
}

/* Tailwind-like Card */
.tw-card {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    padding: 18px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.03), 0 2px 4px -2px rgba(0, 0, 0, 0.03);
    transition: box-shadow 0.2s ease;
}

.tw-card-header {
    display: flex;
    align-items: center;
    gap: 12px;
}

.tw-icon-box {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    border-radius: 10px;
}

.primary-box {
    background-color: #eff6ff;
    border: 1px solid #dbeafe;
}

.purple-box {
    background-color: #eef2ff;
    border: 1px solid #e0e7ff;
}

.tw-title {
    font-size: 1.05rem;
    font-weight: 800;
    color: #0f172a;
    letter-spacing: -0.01em;
    margin: 0;
}

.tw-subtitle {
    display: flex;
    align-items: center;
    font-size: 0.825rem;
    color: #64748b;
    line-height: 1.4;
}

.tw-divider {
    height: 1px;
    background-color: #f1f5f9;
    margin: 8px 0;
}

/* Form Styles */
.tw-form-group {
    display: flex;
    flex-direction: column;
}

.tw-label {
    font-size: 0.8125rem;
    font-weight: 700;
    color: #334155;
    margin-bottom: 6px;
}

.tw-input {
    width: 100%;
    height: 44px;
    background-color: #ffffff;
    border: 1px solid #cbd5e1;
    border-radius: 10px;
    padding: 0 14px;
    font-size: 0.875rem;
    color: #1e293b;
    outline: none;
    transition: all 0.2s ease;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.02);
}

.tw-input:focus {
    border-color: #2563eb;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
}

.tw-select-wrapper {
    position: relative;
    width: 100%;
}

.tw-select {
    width: 100%;
    height: 44px;
    background-color: #ffffff;
    border: 1px solid #cbd5e1;
    border-radius: 10px;
    padding: 0 38px 0 14px;
    font-size: 0.875rem;
    color: #1e293b;
    outline: none;
    appearance: none;
    transition: all 0.2s ease;
    cursor: pointer;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.02);
}

.tw-select:focus {
    border-color: #2563eb;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
}

.tw-select-arrow {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    color: #64748b;
}

/* Inject Button */
.tw-btn-inject {
    width: 100%;
    height: 44px;
    font-size: 0.875rem;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 12px;
    border: none;
    transition: all 0.2s ease;
}

.tw-btn-disabled {
    background-color: #e2e8f0;
    color: #94a3b8;
    cursor: not-allowed;
}

.tw-btn-active {
    background-color: #1d4ed8;
    color: #ffffff;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(29, 78, 216, 0.25);
}

.tw-btn-active:hover {
    background-color: #1e40af;
    transform: translateY(-1px);
}

.tw-btn-active:active {
    transform: translateY(0);
}

/* Sequence List Items */
.tw-sequence-list {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.tw-sequence-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 14px;
    padding: 11px 14px;
    margin-bottom: 0;
    transition: all 0.2s ease;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.02);
}

.tw-sequence-item:hover {
    border-color: #cbd5e1;
    box-shadow: 0 4px 12px -2px rgba(0, 0, 0, 0.06);
}

.drag-handle {
    cursor: grab;
    display: flex;
    align-items: center;
    padding: 4px;
    border-radius: 6px;
}

.drag-handle:active {
    cursor: grabbing;
}

.tw-step-badge {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: #0f172a;
    color: #ffffff;
    font-size: 0.85rem;
    font-weight: 800;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.tw-role-title {
    font-size: 0.7rem;
    font-weight: 800;
    color: #64748b;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    margin-bottom: 2px;
}

.tw-person-name {
    font-size: 0.95rem;
    font-weight: 700;
    color: #1e293b;
}

.tw-action-btn {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    background: transparent;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
}

.tw-edit-btn:hover {
    background-color: #fff7ed;
}

.tw-delete-btn:hover {
    background-color: #fef2f2;
}

/* Dragging Ghost Class */
.tw-ghost-row {
    opacity: 0.5;
    background-color: #eff6ff !important;
    border: 2px dashed #3b82f6 !important;
}

/* Flip List Transitions */
.flip-list-move {
    transition: transform 0.3s ease;
}

/* Custom Switch */
.custom-switch-wrapper {
    position: relative;
    width: 44px;
    height: 24px;
}

.custom-switch-input {
    opacity: 0;
    width: 0;
    height: 0;
}

.custom-switch-slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #cbd5e1;
    transition: .3s;
    border-radius: 24px;
}

.custom-switch-slider:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: .3s;
    border-radius: 50%;
}

.custom-switch-input:checked+.custom-switch-slider {
    background-color: #2563eb;
}

.custom-switch-input:checked+.custom-switch-slider:before {
    transform: translateX(20px);
}
</style>